import { defineMessages } from "react-intl";
import { useFormatMessage } from "../Intl/Context";

const AccessDeniedPage = () => {
  const t = useFormatMessage();
  const title = t(intlMessages.title);
  const description = t(intlMessages.description, { p: message => `<p>${message}</p>` });

  return (
    <div className="container padding-xl box">
      <h1 className="text-title-section margin-bottom-md">{title}</h1>
      <div className="text-default" dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  );
};

export default AccessDeniedPage;

const intlMessages = defineMessages({
  title: {
    id: "main.error.accessDenied.title",
    defaultMessage: "Accès refusé"
  },
  description: {
    id: "main.error.accessDenied.description",
    defaultMessage: `
      <p>
        Vous n'avez pas la permission d'accéder à cette page.
        Si vous pensez qu'il s'agit d'une erreur,
        veuillez contacter l'administrateur de la plateforme.
      </p>
      <p>
        Vous pouvez utiliser le menu principal pour retourner sur la plateforme, ou vous
        connecter avec un compte ayant les droits nécessaires.
      </p>
    `
  }
});
